// Auth helper to get access token
let authContext = null;

export const setAuthContext = (context) => {
  authContext = context;
};

export const getAccessToken = async () => {
  if (!authContext) {
    throw new Error("Auth context not initialized");
  }
  return await authContext.getAccessToken();
};
